var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { GraphQLNonEmptyString } from "graphql-scalars";
import { ArgsType, Field, InputType, ObjectType } from "type-graphql";
import { FilteredListQueryArgs } from "../filtering/FilteredListQueryArgs.js";
import { EventNode } from "../resources/Event.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { IntervalISO } from "../types/IntervalISO.js";
import { AbstractGraphQLPaginatedResponse } from "./PaginatedResponse.js";
let ListEventsResponse = class ListEventsResponse extends AbstractGraphQLPaginatedResponse {
    data;
};
__decorate([
    Field(() => [EventNode], { nullable: false }),
    __metadata("design:type", Array)
], ListEventsResponse.prototype, "data", void 0);
ListEventsResponse = __decorate([
    ObjectType("ListEventsResponse", {
        implements: (AbstractGraphQLPaginatedResponse),
    })
], ListEventsResponse);
export { ListEventsResponse };
let CreateEventOccurrenceInput = class CreateEventOccurrenceInput {
    interval;
    fullDay;
};
__decorate([
    Field(() => IntervalISO, { nullable: false }),
    __metadata("design:type", IntervalISO)
], CreateEventOccurrenceInput.prototype, "interval", void 0);
__decorate([
    Field(() => Boolean, { nullable: false }),
    __metadata("design:type", Boolean)
], CreateEventOccurrenceInput.prototype, "fullDay", void 0);
CreateEventOccurrenceInput = __decorate([
    InputType()
], CreateEventOccurrenceInput);
export { CreateEventOccurrenceInput };
let CreateEventInput = class CreateEventInput {
    title;
    summary;
    location;
    occurrences;
    description;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], CreateEventInput.prototype, "title", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], CreateEventInput.prototype, "summary", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], CreateEventInput.prototype, "location", void 0);
__decorate([
    Field(() => [CreateEventOccurrenceInput], { nullable: false }),
    __metadata("design:type", Array)
], CreateEventInput.prototype, "occurrences", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], CreateEventInput.prototype, "description", void 0);
CreateEventInput = __decorate([
    InputType()
], CreateEventInput);
export { CreateEventInput };
let SetEventOccurrenceInput = class SetEventOccurrenceInput {
    id;
    interval;
    fullDay;
};
__decorate([
    Field(() => GlobalIdScalar, {
        nullable: true,
        description: "If updating an existing occurrence, the GlobalId of the occurrence to update",
    }),
    __metadata("design:type", Object)
], SetEventOccurrenceInput.prototype, "id", void 0);
__decorate([
    Field(() => IntervalISO, { nullable: false }),
    __metadata("design:type", IntervalISO)
], SetEventOccurrenceInput.prototype, "interval", void 0);
__decorate([
    Field(() => Boolean, { nullable: false }),
    __metadata("design:type", Boolean)
], SetEventOccurrenceInput.prototype, "fullDay", void 0);
SetEventOccurrenceInput = __decorate([
    InputType()
], SetEventOccurrenceInput);
export { SetEventOccurrenceInput };
let SetEventInput = class SetEventInput {
    title;
    summary;
    location;
    occurrences;
    description;
};
__decorate([
    Field(),
    __metadata("design:type", String)
], SetEventInput.prototype, "title", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], SetEventInput.prototype, "summary", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], SetEventInput.prototype, "location", void 0);
__decorate([
    Field(() => [SetEventOccurrenceInput], { nullable: false }),
    __metadata("design:type", Array)
], SetEventInput.prototype, "occurrences", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], SetEventInput.prototype, "description", void 0);
SetEventInput = __decorate([
    InputType()
], SetEventInput);
export { SetEventInput };
let ListEventsArgs = class ListEventsArgs extends FilteredListQueryArgs("EventResolver", [
    "title",
    "description",
    "summary",
    "location",
    "occurrences",
    "start",
    "end",
    "createdAt",
    "updatedAt",
]) {
};
ListEventsArgs = __decorate([
    ArgsType()
], ListEventsArgs);
export { ListEventsArgs };
//# sourceMappingURL=eventParams.js.map